import React from 'react';


import { Container, ContainerWhite } from './styles';

const Programacao: React.FC = () => {

  return (
    <>


      <Container >

    <h2 className='title'> PROGRAMAÇÃO</h2> 
<strong>12º Encontro de Previdência Complementar – Região Sul</strong>
<p>17 e 18 de maio de 2022, On-line</p>



<h2>Dia 17 de maio, 13h30 às 19h15 </h2>

<table style={{width: '100%'}}>
  <tr><td>13h30</td><td><div className='high-description'>ABERTURA OFICIAL DO EVENTO</div></td></tr>
</table>

<div className='high'>
<strong>Painel 1: ATUALIZAÇÃO DA LEGISLAÇÃO E OPORTUNIDADES PARA O SEGMENTO</strong>
</div>

<table style={{width: '100%'}}>
  <tr><td>13h55</td>
  <td><div className='high-description'>
PALESTRA 1:
<strong className='yellowColor'> <br/>Panoramas e Perspectivas da Previdência Complementar</strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Lúcio Capelletto</strong><strong> - Diretor-Superintendente da Superintendência Nacional de Previdência Complementar-Previc </strong>
 </div></td></tr>
</table>



<table style={{width: '100%'}}>
    <tr>
      <td>14h15</td>
      <td><div className='high-description'>
  PALESTRA 2:

<br/><strong className='yellowColor'> Oportunidades e Perspectivas do Segmento de Previdência com base na Legislação </strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Luís Ricardo Marcondes Martins</strong><strong> - Diretor-Presidente da Abrapp </strong>
</div></td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>14h35</td>
      <td><div className='high-description'>
 <strong className='yellowColor'>DEBATE + PERGUNTAS: </strong>
<br/><br/>Debatedor: 
<br/><strong className='yellowColor2'>Sérgio Rangel</strong><strong> - Atuário e Consultor Sênior da Mirador </strong>
<br/><br/>Mediador:
<br/><strong className='yellowColor2'>Tulio Milman</strong><strong> - Jornalista </strong>
</div></td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>15h15</td>
      <td><div className='high-description'>INTERVALO</div></td>
    </tr>

</table> 
<div className='high'>
<strong>Painel 2: GESTÃO DE ENTIDADES – GESTÃO DE PESSOAS E COMUNICAÇÃO PARA RESULTADOS</strong>
</div>

<table style={{width: '100%'}}>
    <tr>
      <td>15h40</td>
      <td>
      <div className='high-description'>
PALESTRA 1:<strong className='yellowColor'>
  <br/> Gestão de Talentos - Desenvolver Grupos de Alta Performance</strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Walérya Carriço</strong><strong> - Consultora para Desenvolvimento de Executivos e Coaching de CEOs</strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>16h25</td>
      <td><div className='high-description'>
<strong className='yellowColor'>DEBATE + PERGUNTAS: </strong>
<br/><br/>Debatedora: 
<br/><strong className='yellowColor2'>Claudia Trindade</strong><strong> - Presidente da Previpar</strong>
</div></td>
    </tr>

</table>


<table style={{width: '100%'}}>
    <tr>
      <td>17h05</td>
      <td><div className='high-description'>INTERVALO</div></td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>17h20</td>
      <td>
      <div className='high-description'>
PALESTRA 2: 
<strong className='yellowColor'><br/>Estratégias Digitais na Comunicação com o Participante </strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Cleber Paradela</strong><strong> - Estrategista Digital do Aplicativo 99</strong>
</div>

      </td>
    </tr>

</table>







<table style={{width: '100%'}}>
    <tr>
      <td>18h05</td>
      <td><div className='high-description'>
 <strong className='yellowColor'>DEBATE + PERGUNTAS</strong>
 <br/><br/>Debatedora: 
<br/><strong className='yellowColor2'>Denise Pagnussatt</strong><strong> - Coord. do Curso de Comunicação Empresarial e de Relações Públicas da PUCRS</strong>

</div>
</td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>18h45</td>
      <td><div className='high-description'>ENCERRAMENTO</div></td>
    </tr>

</table> 

<h2>Dia 18 de maio, 13h30 às 17h40 </h2>
 

<table style={{width: '100%'}}>
    <tr>
      <td>13h30</td>
      <td>
      <div className='high-description'>
ABERTURA
 
</div>

      </td>
    </tr>

</table>

<div className='high'>
<strong>Painel 3: MERCADO, DESAFIOS E OPORTUNIDADES EM INVESTIMENTO </strong>
</div>



<table style={{width: '100%'}}>
    <tr>
      <td>13h35</td>
      <td>
      <div className='high-description'>
PALESTRA 1: 
<strong className='yellowColor'><br/>Estratégias de Investimento</strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Marcos Lélis</strong><strong> - Professor do Programa de Pós-Graduação em Economia da Unisinos</strong>

</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>13h55</td>
      <td>
      <div className='high-description'>
PALESTRA 2:
<strong className='yellowColor'><br/>Oportunidades de Investimento em um Cenário Adverso </strong>

<br/><br/>
Palestrante:
  <strong className='yellowColor2'  > <br/>Philipe Biolchini </strong><strong> - CIO da Bradesco Asset Management (BRAM)</strong>
  </div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>14h10</td>
      <td>
      <div className='high-description'>
  <strong className='yellowColor'>DEBATE + PERGUNTAS: </strong>
<br/><br/>Debatedores: 
<br/><strong className='yellowColor2'>Julio Fernandes</strong><strong> - Gestor de Multimercado da XP Asset </strong>
<br/><strong className='yellowColor2'>Rafael Rocha Luzardo</strong><strong> - Diretor Financeiro e Administrativo da Tchê Previdência </strong>
<br/><br/>Mediador:<br/><strong className='yellowColor2'> Tulio Milman</strong><strong> - Jornalista </strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>15h00</td>
      <td>
      <div className='high-description'>
PALESTRA ESPECIAL:
<strong className='yellowColor'>Previdência Complementar: transitando para Previdência Principal </strong>

<br/><br/>
 
  <strong className='yellowColor2'  > <br/>Geraldo Biasoto Júnior</strong><strong> - Professor do Instituto de Economia da Unicamp</strong>
  </div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>15h25</td>
      <td>
      <div className='high-description'>
  <strong className='yellowColor'>DEBATE + PERGUNTAS: </strong>
<br/><br/>Debatedora: 
<br/><strong className='yellowColor2'>Magdarlise Dal Fiume Germany</strong><strong> - Sócia e Diretora da Mirador</strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>15h40</td>
      <td><div className='high-description'>INTERVALO</div></td>
    </tr>

</table>








<div className='high'>
<strong>Painel 4: PERSPECTIVAS POLÍTICAS E ECONÔMICAS – POSSÍVEIS IMPACTOS NA GESTÃO DA PREVIDÊNCIA </strong>
</div>

<table style={{width: '100%'}}>
    <tr>
      <td></td>
      <td></td>
    </tr>

</table>


<table style={{width: '100%'}}>
    <tr>
      <td>16h20</td>
      <td>
      <div className='high-description'>
PALESTRA 1: 
<strong className='yellowColor'><br/>Perspectivas Políticas para 2022 </strong>
<br/><br/>Palestrante:  
<br/><strong className='yellowColor2'>Paulo Gama</strong><strong> - Analista Político da XP Investimentos </strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>16h40</td>
      <td>
      <div className='high-description'>
PALESTRA 2: 
<br/><strong className='yellowColor'>Perspectivas Econômicas para a Previdência </strong>
<br/><br/>Palestrante: 
<br/><strong className='yellowColor2'>Zeina Latif</strong><strong> - Consultora Econômica</strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>17h10</td>
      <td>
      <div className='high-description'>
 <strong className='yellowColor'>DEBATE + PERGUNTAS: </strong>
<br/><br/>Debatedor: 
<br/><strong className='yellowColor2'>Adimilson Luiz Stodulski</strong><strong> - Diretor-Presidente da Tchê Previdência </strong>
<br/><br/>Mediador: 
<br/><strong className='yellowColor2'>Tulio Milman</strong><strong> - Jornalista </strong>
</div>

      </td>
    </tr>

</table>

<table style={{width: '100%'}}>
    <tr>
      <td>18h00</td>
      <td><div className='high-description'> ENCERRAMENTO OFICIAL DO EVENTO</div></td>
    </tr>

</table> 

      </Container>
    </>
  );
};
export default Programacao;
